import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=c58cd2b0&scoped=true&"
import script from "./DocumentListItem.vue?vue&type=script&lang=js&"
export * from "./DocumentListItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=c58cd2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58cd2b0",
  null
  
)

export default component.exports